import { CONFIG } from '../config';

type Card = {
  holderName: string;
  number?: string;
  expiryMonth: string;
  expiryYear: string;
  cvc: string;
};

export const encryptCard = (card: Card): string => {
  if (!window.adyen) throw new Error('encryptCard: adyen CSE script is not loaded');
  const cseInstance = window.adyen.encrypt.createEncryption(CONFIG.ADYEN_CSE_PUBLIC_KEY, {});
  return cseInstance.encrypt({
    ...card,
    generationtime: window.__SERVER_TIME__ || new Date().toISOString()
  });
};
